export const datas = [
  {
    id: 1,
    imageUrl:
      "https://static-01.daraz.com.np/p/a1f6c42c7bb4cfcd0655be7725ffef53.jpg",
    title: "Dusters & Dust Cloths",
  },
  {
    id: 2,
    imageUrl:
      "https://static-01.daraz.com.np/p/941634223f8514ef7a962dbb49e2d3ea.jpg",
    title: "Bath Toys",
  },
  {
    id: 3,
    imageUrl:
      "https://static-01.daraz.com.np/p/a1c9c7c262f5a819ae5b527ef809f2b0.png",
    title: "Mobiles",
  },
  {
    id: 4,
    imageUrl:
      "https://static-01.daraz.com.np/p/b2d5251bc7782771a7002cfd069cafe1.jpg",
    title: "Cables",
  },
  {
    id: 5,
    imageUrl:
      "https://static-01.daraz.com.np/p/62007f2fd8126820529d311e164fcd91.jpg",
    title: "SD & SDHC Cards",
  },
  {
    id: 6,
    imageUrl:
      "https://static-01.daraz.com.np/p/3ccebbc5cda15871981b4abc88dabd7c.jpg",
    title: "Micro SD Cards",
  },
  {
    id: 7,
    imageUrl:
      "https://static-01.daraz.com.np/p/651cc196c6a6bd27d1119c5bda87dcb3.jpg",
    title: "Tote Bags",
  },
  {
    id: 8,
    imageUrl:
      "https://static-01.daraz.com.np/p/c57665abbd4c50863b6e10561386d108.jpg",
    title: "Cross Body & Shoulder Bags",
  },
  {
    id: 9,
    imageUrl:
      "https://static-01.daraz.com.np/original/999ac41786f001931c183d815d35100b.jpg",
    title: "Others Electronic Gadgets",
  },
  {
    id: 10,
    imageUrl:
      "https://static-01.daraz.com.np/p/f70bc69ed48daa6be78d36205a006e03.png",
    title: "QLED Televisions",
  },
  {
    id: 11,
    imageUrl:
      "https://static-01.daraz.com.np/p/33ea5c9310000c1a8930eec117e3fdb2.jpg",
    title: "Eye Drops",
  },
  {
    id: 12,
    imageUrl:
      "https://static-01.daraz.com.np/p/be55c54c75e450c0503b936c57c78cd6.jpg",
    title: "Pillow Cases",
  },
  {
    id: 13,
    imageUrl:
      "https://static-01.daraz.com.np/p/7050595d3340b00d141933917d819d0e.jpg",
    title: "Adult Diapers & Incontience",
  },
  {
    id: 14,
    imageUrl:
      "https://static-01.daraz.com.np/p/8c0d56abe057bdcc752db8618f7ce402.png",
    title: "Repair",
  },
  {
    id: 15,
    imageUrl:
      "https://static-01.daraz.com.np/p/0a55272db86f39d438290f0070d8bb72.jpg",
    title: "Dogs & Cat Brushes & Combs",
  },
  {
    id: 16,
    imageUrl:
      "https://static-01.daraz.com.np/p/d4175af6bb21665926b1a5ec107003b4.jpg",
    title: "Landline Phones",
  },
];